import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription, timer } from 'rxjs';

@Component({
  selector: 'app-clock-down',
  templateUrl: './clock-down.component.html',
  styleUrls: ['./clock-down.component.css']
})
export class ClockDownComponent implements OnInit {

  @Output()
    resetCount = new EventEmitter();

  timer = 1000;
  source;
  subscribeCount: Subscription;
  
  time : {
    minutes: string;
    seconds: string
  }

  @Input()
  totalTime = 120;

  percentTime: number;

  constructor() {
    document.documentElement.style.setProperty("--percent-circle", "90");
   }

  ngOnInit(): void {
    this.source = timer(0, 1000);
    this.time = {
      minutes : "", 
      seconds: ""
    }
    this.subscribeCount = this.updateTime();
  }

  ngOnDestroy() {
    this.subscribeCount.unsubscribe();
  }

  updateTime(){
    return this.source
      .subscribe(t => {
        if(this.time.minutes !== "00" || this.time.seconds !== "00"){
          const totalSeconds = 60;
          const totalStringSeconds = 2;
          const totalPercent = 100;

          const countSeconds = this.totalTime - t
          const seconds = (countSeconds % totalSeconds).toString();
          const minutes = (Math.floor(countSeconds/totalSeconds)).toString();
          this.time.seconds = seconds.length < totalStringSeconds ? "0" + seconds: seconds.toString()
          this.time.minutes = minutes.length < totalStringSeconds ? "0" + minutes: seconds.toString()
          this.percentTime = t * totalPercent / this.totalTime
        }
        else{
          this.resetCount.emit()
        }
    })
  }

  reset(){
    this.time = {
      minutes : "", 
      seconds: ""
    };
    this.subscribeCount.unsubscribe();
    this.subscribeCount = this.updateTime();
  }

  @Input() set restartCount(restart: boolean) {
    if(restart){
      this.reset()
    }
  }
}
